import React from "react";

const BlogStyle2 = () => {
    return (
        <div className="blog-style2">
            <div className="blog-img">
                <img src="/assets/img/blog/blog_3_2_4.jpg" alt="blog image" />
            </div>
            <div className="blog-content">
                <a
                    data-theme-color="#59C2D6"
                    href="blog.html"
                    className="category"
                >
                    Fashion
                </a>
                <h3 className="box-title-20">
                    <a className="hover-line" href="blog-details.html">
                        Fashion is an art, express Yourself beautifully
                    </a>
                </h3>
                <div className="blog-meta">
                    <a href="blog.html">
                        <i className="fal fa-calendar-days"></i>
                        10 Mar, 2023
                    </a>
                </div>
            </div>
        </div>
    );
};

export default BlogStyle2;
